// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';
import { startWaldo } from './waldo';
import './index.css';
import './App.css';

// Analytics — enabled only in local development for now.
// Set REACT_APP_PUBLIC_POSTHOG_KEY in .env to turn it on.
const posthogEnabled =
  process.env.NODE_ENV === 'development' &&
  Boolean(process.env.REACT_APP_PUBLIC_POSTHOG_KEY);

if (posthogEnabled) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    defaults: '2026-05-30',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  });
}

// Waldo confusion detector — reports to PostHog + shows the feedback chat widget.
startWaldo();

const container = document.getElementById('root');
const root = createRoot(container);

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

root.render(
  posthogEnabled ? <PostHogProvider client={posthog}>{app}</PostHogProvider> : app
);
